import React, { memo } from "react";
import * as PropTypes from "prop-types";
import { getGniGroupCode } from "../../../utilities";
import { withStyles } from "@material-ui/core";
import styleConstants from "../../../styleConstants";
import PanelChart from "../../chart/PanelChart";
import SmallLineChart from "../../chart/SmallLineChart";

const styles = {
  smallLineChart: {
    padding: "0 5px",
    border: `0px ${styleConstants.colors.gray3} solid`
  }
};

const ChangeByGniGroupChart = props => {
  const maximumValue = Math.max(...props.data.map(datum => datum.value));

  return (
    <PanelChart>
      {[
        "Low-Income (LIC)",
        "Lower-Middle-Income (L-MIC)",
        "Upper-Middle-Income (U-MIC)"
      ].map((area, index) => {
        const chartTitle = getGniGroupCode(area);

        const series = {
          name: chartTitle,
          color: styleConstants.categoryColors.gniGroupColors[chartTitle],
          data: props.data
            .filter(datum => datum.area === area)
            .map(datum => ({
              ...datum,
              year: parseInt(datum.year, 10)
            }))
            .sort((a, b) => a.year - b.year)
            .map(datum => [datum.year, datum.value])
        };

        return (
          <SmallLineChart
            key={area}
            title={chartTitle}
            marginLeft={index === 0 ? 60 : 0}
            width={index === 0 ? 160 : 100}
            yAxis={{
              title: index === 0 ? props.yAxisTitle : undefined,
              minimum: 0,
              maximum: maximumValue,
              showLabels: index === 0
            }}
            series={[series]}
            tooltipFormatter={props.tooltipFormatter}
            className={props.classes.smallLineChart}
            onRegisterChartRef={ref => {
              props.onRegisterChartRef(index, ref);
            }}
          />
        );
      })}
    </PanelChart>
  );
};

ChangeByGniGroupChart.propTypes = {
  data: PropTypes.array.isRequired,
  yAxisTitle: PropTypes.string,
  tooltipFormatter: PropTypes.func,
  onRegisterChartRef: PropTypes.func.isRequired
};

export default memo(withStyles(styles)(ChangeByGniGroupChart));
